import './App.css';
import { Routes, Route } from "react-router-dom"
import LoginPage from './pages/LoginPage';
import SignUpPage from './pages/SignUpPage';
import ResetPage from './pages/ResetPage';
import HomePage from './pages/HomePage';
import NotesPage from './pages/NotesPage';
import PublicRoute from './routing/PublicRoute';
import PrivateRoute from './routing/PrivateRoute';
import NotFoundPage from './components/Error/js/NotFoundPage';
import DemoPage from './pages/DemoPage';
import DemoErrorPage from './pages/DemoErrorPage';
import SkeletonPage from './components/board/js/SkeletonPage';
import UseMobileLayout from './hooks/useMobileLayout';

function App() {
  return (
      <Routes>
        <Route path = "" element = {<HomePage/>}/>
        <Route path = "/login" element = {<PublicRoute><LoginPage/></PublicRoute>}/>
        <Route path = "/signup" element = {<PublicRoute><SignUpPage/></PublicRoute>}/>
        <Route path = "/forgot-password" element = {<ResetPage/>}/>
        <Route path = "/notes" element = {<PrivateRoute><NotesPage/></PrivateRoute>}/>
        <Route path = "/demo" element = {<DemoPage/>}/>
        <Route path = "/demo-error" element = {<DemoErrorPage/>}/>
        <Route path = "*" element = {<NotFoundPage/>}/>
      </Routes>
  );
}

export default App;
